import { useTranslation } from "react-i18next";
import { baseUrl } from "../../services";
import { useSelector } from "react-redux";

const CombinedCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  const { authorization } = useSelector((state) => state.auth);

  return (
    <article className="buy-and-supply__card buy-and-supply-2026__card h-100 d-flex flex-column">
      <img
        src={baseUrl + data?.image}
        alt=""
        className="d-block img-fluid"
        loading="lazy"
      />
      <div className="buy-and-supply__card__data-holder flex-fill d-flex flex-column justify-content-between">
        <div className="buy-and-supply-2026__card__info">
          <p className="fsize-5 fw-bold green-text">{data?.itemName}</p>
          <p className="fw-500 fsize-11 main-dark-text">{data?.category}</p>
          <p className="buy-and-supply-2026__card__limit fw-400">
            {t("buyAndSupply2026.currentAvailablePurchaseLimit")}{" "}
            <strong>
              {data?.availablePurchaseLimit ?? 0} {t("buyAndSupply2026.kilo")}
            </strong>
          </p>
        </div>
        <div className="buy-and-supply__card__boxes-holder d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="buy-and-supply__card__boxes-holder__value text--secondary-8 fw-700 fsize-6 text-truncate">
              {data?.pricePerKilo}
            </span>
            <span className="text--secondary-8 fw-700 fsize-12 text-center">
              {authorization?.isEmirate
                ? t("buyAndSupply.AEDPerKg")
                : t("buyAndSupply.EGPPerKg")}
            </span>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="buy-and-supply__card__boxes-holder__value text--secondary-8 fw-700 fsize-6 text-truncate">
              {data?.quantityPerKilo}
            </span>
            <span className="text--secondary-8 fw-700 fsize-12 text-center">
              {t("buyAndSupply.availableInStore")}
            </span>
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={() => onOpen(data)}
        className="buy-and-supply-2026__card__cta border-0 outline-0 shadow-none w-100  fw-bold fsize-6 green-text"
      >
        {t("buyAndSupply2026.cta")}
      </button>
    </article>
  );
};

export default CombinedCard;
